module.exports = __webpack_public_path__ + "img/about3.8aec8cc1.png";